// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-light-info[data-v-554cf896]{border:1px solid transparent}.bg-light-info[data-v-554cf896]:hover{border:1px solid #2fa4e5}.bg-light-danger[data-v-554cf896]{border:1px solid transparent}.bg-light-danger[data-v-554cf896]:hover{border:1px solid #ef5350}", ""]);
// Exports
module.exports = exports;
